window.baseApp = null;
$(document).ready(function () {
    if ($('#baseApp').length > 0) {
        
        window.baseApp = new Vue({
            el: '#baseApp',
            data: {
                configApp:null
            },
            mounted:function () {
                // httpRequest(base_url+'api/v1/getConfig',{},{type:'get',showLoader:false}).then(onResult => {
                //     if (onResult.result) {
                //         this.configApp = onResult.data;
                //         this.$refs.cart.inizialize();
                //     }
                // });
            },
            computed: {
                
            },
            watch: {
               
            },
            methods: {
                
                
            }
        });
    }
})